import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import auth from "../services/authService";
import config from "../config.json";
import Pagination from "../comman/pagination";
import { paginate, calculateIndex } from "../utlis/paginate";
import PartnerPerformerTable from "./PartnerPerformerTable";
import PageSizeOptions from "./PageSizeOptions";
import ActiveDeactiveHistory from "./SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { getLoggedUser, getLoggedUserDetails, getCurrentUser } from "../app/store/auth";
import {
  getSubcontractorPerformers, loadSubcontractorPerformers,
  AddSubcontractorPerformer, getAddedSubPerformerStatus,
  loadSubcontractorBprmForm,
  getSubcontractorBprmForm,
  loadSubcontractorsByFilter,
  getFilterAllSubcontractors
} from "../app/store/subcontractor";
import {
  getRecruiterPerformers, loadRecruiterPerformers,
  AddRecruiterPerformer, getAddedRecPerfromerStatus,
  loadRecruiterBprmForm,
  getRecruiterBprmForm,
  getReminderStatus,
  loadRecruiters,
  getFilterAllRecruiters,
  reminderSent
} from "../app/store/recruiter";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getFormatedNumber } from "../services/appService";
import Moment from "react-moment";
import { SendReminder } from "../app/store/recruiter";
import { Tab, Tabs } from "react-bootstrap";
import WorkflowElement from "../app/components/WorkflowElement";
import { getAlert } from "../services/appAlerts";
import AddPartnerPerformer from "./AddPartnerPerformer";

export default function ManagePartnerPerformer(props) {

  const routeArray = [
    { name: "System Administration", url: "" },
    { name: "Manage Entities", url: "" },
  ];
  //const [route,setRoute]=useState(routeArray)
  const [partnerType, setPartnerType] = useState("Recruiter")
  const [performers, setPerformers] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [rowsCount, setRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState(null);
  const [currentUser, setCurrentUser] = useState("");
  const [loggedUser, setLoggedUser] = useState("");

  const [performerId, setPerformerId] = useState("");
  const [performerName, setPerformerName] = useState("");
  const [mobile, setMobile] = useState("");

  const [actionType, setActionType] = useState("action");
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [selectedKey, setSelectedKey] = useState("home");
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [performerdata, setPerformerdata] = useState({});
  const [dataType, setDataType] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);

  const subcontractorPerformers = useSelector(getSubcontractorPerformers);
  const recruiterPerformers = useSelector(getRecruiterPerformers);

  const subPerformerAdded = useSelector(getAddedSubPerformerStatus);
  const recPerformerAdded = useSelector(getAddedRecPerfromerStatus);

  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);

  const userDetails = useSelector(getLoggedUserDetails);
  const remiderStatus = useSelector(getReminderStatus);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector])

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    const state = location?.state;
    if (state?.partner && state?.url) {
      routeArray.push({ name: state.partner, url: state.url });
    }
    dispatch(setCurrentRoute(routeArray));
    dispatch(setCurrentPageTitle("Manage Users"))
  }, [])


  useEffect(() => {
    const state = location?.state;
    var frmBody = new FormData();
    frmBody.append("name", "");
    frmBody.append("email", "");
    if (state?.obj) {
      const currentObj = state.obj;
      setCurrentUser(currentObj);
      if (currentObj?.partnerType === "Sub-Contractors") {
        setPartnerType("Subcontractor");
        if (currentObj?.fuid) {
          dispatch(loadSubcontractorPerformers(currentObj.fuid));
        }
        frmBody.append("id", currentObj?.fuid || "");
        frmBody.append("type", "Sub-Contractors");
        dispatch(loadSubcontractorsByFilter(frmBody));
      }
      else {
        if (currentObj?.fuid) {
          dispatch(loadRecruiterPerformers(currentObj.fuid));
        }
        frmBody.append("id", currentObj?.fuid || "");
        frmBody.append("type", "Recruiter");
        dispatch(loadSubcontractorsByFilter(frmBody));
      }
    }
  }, []);

  useEffect(() => {
    setPerformerdata(filterAllRecruiters[0])
  }, [filterAllRecruiters])

  useEffect(() => {
    setPerformerdata(filterAllSubcontractors[0])
  }, [filterAllSubcontractors])

  useEffect(() => {
    getPagedData(subcontractorPerformers, currentPage, pageSize);
  }, [subcontractorPerformers]);

  useEffect(() => {
    getPagedData(recruiterPerformers, currentPage, pageSize);
  }, [recruiterPerformers]);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.type === "admin" && userDetails !== null) {
      const usrDetails = { ...userDetails, roleType: "admin" };
      setLoggedUser(usrDetails);
    }
  }, [userDetails]);

  useEffect(() => {
    if (subPerformerAdded && currentUser?.fuid) {
      dispatch(loadSubcontractorPerformers(currentUser.fuid));
    }
  }, [subPerformerAdded])

  useEffect(() => {
    if (recPerformerAdded && currentUser?.fuid) {
      dispatch(loadRecruiterPerformers(currentUser.fuid));
    }
  }, [recPerformerAdded])


  const handleSelection = (item) => {
    if (selectedUserId === item.id) {
      handleResetSelection();
      return;
    }
    const obj = performers.filter(x => x.id === item.id);
    if (obj.length > 0) {
      setSelectedObj(obj[0]);
      setSelectedUserId(item.id);
    }
  };


  const handleFormSubmit = (performer) => {
    if (currentUser?.fuid > 0) {
      performer["partnerId"] = currentUser.fuid;
      if (partnerType === "Subcontractor")
        dispatch(AddSubcontractorPerformer(performer));
      else
        dispatch(AddRecruiterPerformer(performer));
      setShowHide(!showHide);
    }
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    setRowsCount(list.length);
    setPerformers(items);
  };

  const handleLogShowHide = (item, actionType) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);
      if (partnerType === "Subcontractor") {
        if (currentUser?.fuid) {
          dispatch(loadSubcontractorPerformers(currentUser.fuid));
        }
      } else {
        if (currentUser?.fuid) {
          dispatch(loadRecruiterPerformers(currentUser.fuid));
        }
      }
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);
    }
  };

  const handleTabSelect = (tab) => {
    setSelectedKey(tab);
  }

  const getSourcePerformers = () =>
    partnerType === "Subcontractor" ? subcontractorPerformers : recruiterPerformers;

  const handleFilter = async () => {
    setIsFiltering(true);
    let filtered =
      performerId !== ""
        ? getSourcePerformers().filter((p) => p.id === parseInt(performerId))
        : getSourcePerformers();

    filtered =
      performerName !== ""
        ? filtered.filter((x) =>
          x.name?.toLowerCase().includes(performerName.toLowerCase())
        )
        : filtered;

    filtered =
      mobile !== ""
        ? filtered.filter((x) => x.contact && x.contact.includes(mobile))
        : filtered;

    getPagedData(filtered, 1, pageSize)
    setDataType("filter");
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = () => {
    getPagedData(getSourcePerformers(), 1, pageSize);

    setPerformerId("");
    setPerformerName("");
    setMobile("");
    setDataType("");
    setIsFiltering(false);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const n = value.replace(/[^\d]/g, "");
    if (n.length < 4) return n;
    if (n.length < 7) return n.slice(0, 3) + "-" + n.slice(3);
    return n.slice(0, 3) + "-" + n.slice(3, 6) + "-" + n.slice(6, 10);
  };

  const getDisplayName = (performer) =>
    [performer?.name, performer?.lastName].filter(Boolean).join(" ").trim() || "Unnamed User";

  const getInitials = (performer) => {
    const nameParts = getDisplayName(performer).split(" ").filter(Boolean);
    return nameParts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
  };


  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (partnerType === "Subcontractor")
      getPagedData(subcontractorPerformers, page, pageSize);
    else
      getPagedData(recruiterPerformers, page, pageSize);
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    const newSize = Number(currentTarget.value);
    setPageSize(newSize);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (partnerType === "Subcontractor")
      getPagedData(subcontractorPerformers, 1, newSize);
    else
      getPagedData(recruiterPerformers, 1, newSize);
  };

  const handleNextTask = () => {
    console.log("")
  }

  const handleViewSubcontractorForm = (type, item) => {
    if (viewFormType === type) {
      setViewFormType("");
      setUpdatedStateData(null)
    } else {
      if (item.partnerType === "Sub-Contractors") {
        setWfTask({ formId: config.formIds.subcontractor, ciid: 0 });
        dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor))
      } else {
        setWfTask({ formId: config.formIds.recruiter, ciid: 0 });
        dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
      }
      setViewFormType(type);
      setUpdatedStateData(item.contact1.performerData);
    }
  }

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  useEffect(() => {
    const state = location?.state;
    var frmBody = new FormData();
    frmBody.append("name", "");
    frmBody.append("email", "");
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (state?.obj) {
        const currentObj = state.obj;
        if (currentObj?.partnerType === "Sub-Contractors") {
          frmBody.append("id", currentObj?.fuid);
          frmBody.append("type", "Sub-Contractors");
          dispatch(loadSubcontractorsByFilter(frmBody));
        }
        else {
          frmBody.append("id", currentObj?.fuid);
          frmBody.append("type", "Recruiter");
          dispatch(loadSubcontractorsByFilter(frmBody));
        }
      }
    }
    dispatch(reminderSent())
  }, [remiderStatus])

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handleResetSelection = () => {
    setSelectedUserId(0);
    setSelectedObj(null);
  }

  const handlePermissionShowHide = () => {
    handleResetSelection()
    setSelectedKey("home");
  };

  const handlePermissionShowHide2 = () => {
    if (currentUser?.fuid) {
      if (partnerType === "Subcontractor") {
        dispatch(loadSubcontractorPerformers(currentUser.fuid, true));
      } else {
        dispatch(loadRecruiterPerformers(currentUser.fuid, true));
      }
    }
    setSelectedKey("home");
  };

  const handleAddUser = () => {
    handleResetSelection();
    setSelectedKey("addedituser");
  };

  const handleRefresh = () => {
    if (currentUser?.fuid) {
      if (partnerType === "Subcontractor") {
        dispatch(loadSubcontractorPerformers(currentUser.fuid, true));
      } else {
        dispatch(loadRecruiterPerformers(currentUser.fuid, true));
      }
    }
  };

  let item = "";
  if (currentUser) item = currentUser;
  const activeCount = getSourcePerformers().filter(p => p.status).length;

  return (
    <React.Fragment>
      <style>{`
        /* ── Animations ── */
        @keyframes searchSlideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }
        @keyframes loadingBar {
          0%   { width: 0%;   opacity: 1; }
          70%  { width: 85%;  opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Badges ── */
        .badge-capsule {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          padding: 4px 10px !important; border-radius: 20px !important;
          font-size: 12px !important; font-weight: 600 !important; line-height: 1 !important;
        }
        .badge-system { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
        .badge-azure { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }
        .badge-active { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-inactive { background: rgba(239,68,68,0.08) !important; color: #b91c1c !important; border: 1px solid rgba(239,68,68,0.15) !important; }
        .badge-success-modern { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-warning-modern { background: rgba(245,158,11,0.08) !important; color: #b45309 !important; border: 1px solid rgba(245,158,11,0.15) !important; }

        /* Neutral ManageWorkflowPerformer theme. */
        .manage-partner-performer-page {
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06),
            0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          color: #000 !important;
        }
        .manage-partner-performer-page .wf-header-section { padding: 22px 24px 18px !important; background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important; border-bottom-color: #f1f5f9 !important; }
        .manage-partner-performer-page .wf-icon-box { background: #f5f5f5 !important; border: 1px solid #d4d4d4 !important; color: #525252 !important; box-shadow: none !important; }
        .manage-partner-performer-page .wf-title button { color: #171717 !important; font-size: 18px !important; font-weight: 600 !important; text-decoration: none !important; }
        .manage-partner-performer-page .wf-header-meta { margin-top: 10px !important; }
        .manage-partner-performer-page .wf-subtitle,
        .manage-partner-performer-page .legacy-partner-meta,
        .manage-partner-performer-page .wf-toolbar .wf-meta-pill { display: none !important; }
        .manage-partner-performer-page .wf-meta-pill { background: #fafafa !important; border-color: #d4d4d4 !important; color: #525252 !important; font-weight: 600 !important; }
        .manage-partner-performer-page .wf-meta-pill i { color: #525252 !important; }
        .manage-partner-performer-page .wf-meta-pill.is-active i { color: #047857 !important; }
        .manage-partner-performer-page .wf-meta-pill.is-inactive i { color: #b91c1c !important; }
        .manage-partner-performer-page .wf-toolbar { padding: 12px 20px !important; border-bottom-color: #f1f5f9 !important; }
        .manage-partner-performer-page .btn-search-trigger,
        .manage-partner-performer-page .btn-action-search,
        .manage-partner-performer-page .btn-action-search.btn-primary-search {
          background: #fff !important; border: 1px solid #d1d5db !important; color: #404040 !important;
          font-size: 13px !important; font-weight: 400 !important; box-shadow: none !important; transform: none !important;
        }
        .manage-partner-performer-page .btn-search-trigger:hover,
        .manage-partner-performer-page .btn-action-search:hover,
        .manage-partner-performer-page .btn-action-search.btn-primary-search:hover {
          background: #f5f5f5 !important; border-color: #a3a3a3 !important; color: #171717 !important; box-shadow: none !important; transform: none !important;
        }
        .manage-partner-performer-page .btn-search-trigger i,
        .manage-partner-performer-page .btn-action-search i { color: #94a3b8 !important; }
        .manage-partner-performer-page .btn-action-search.btn-danger-search { background: #fff7f7 !important; border-color: #fecaca !important; color: #dc2626 !important; }
        .manage-partner-performer-page .btn-action-search.btn-danger-search i { color: #ef4444 !important; }
        .manage-partner-performer-page .search-panel-collapse { box-shadow: none !important; background: #fff !important; border-color: #d1d5db !important; }
        .manage-partner-performer-page .sp-header-title i { color: #525252 !important; }
        .manage-partner-performer-page .wf-control-label i,
        .manage-partner-performer-page .wf-input-icon { display: none !important; }
        .manage-partner-performer-page .wf-input { padding: 9px 14px !important; color: #171717 !important; font-size: 13px !important; box-shadow: none !important; }
        .manage-partner-performer-page .wf-input:focus { border-color: #737373 !important; box-shadow: 0 0 0 3px rgba(0,0,0,.06) !important; }
        .manage-partner-performer-page .sp-footer { justify-content: center !important; }
        .manage-partner-performer-page .wf-tab-bar { align-items: stretch !important; gap: 6px !important; padding: 8px 0 0 !important; border-bottom: 2px solid #e5e7eb !important; overflow: hidden !important; }
        .manage-partner-performer-page .wf-tab-btn {
          min-height: 42px !important; margin: 0 0 -2px !important; border-radius: 10px 10px 0 0 !important;
          background: transparent !important; color: #404040 !important; font-size: 13px !important; font-weight: 400 !important;
          align-self: stretch !important; box-shadow: none !important;
        }
        .manage-partner-performer-page .wf-tab-btn:hover { background: #f5f5f5 !important; color: #171717 !important; }
        .manage-partner-performer-page .wf-tab-btn > i { color: #94a3b8 !important; }
        .manage-partner-performer-page .wf-tab-btn.active,
        .manage-partner-performer-page .wf-tab-btn.active:hover { background: #171717 !important; color: #fff !important; }
        .manage-partner-performer-page .wf-tab-btn.active > i { color: #fff !important; }
        .manage-partner-performer-page .wf-tab-btn::after { display: none !important; }
        .manage-partner-performer-page .wf-tab-btn.active .wf-tab-badge { background: #fff !important; border-color: #fff !important; color: #171717 !important; }
        .manage-partner-performer-page .wf-assign-card { background: linear-gradient(135deg,#fff 0%,#f5f5f5 100%) !important; border-color: #d4d4d4 !important; box-shadow: none !important; }
        .manage-partner-performer-page .wf-assign-avatar { background: #171717 !important; color: #fff !important; box-shadow: none !important; }
        .manage-partner-performer-page .wf-assign-meta strong { color: #171717 !important; font-weight: 600 !important; text-transform: uppercase !important; }
        .manage-partner-performer-page .wf-assign-meta > span { color: #525252 !important; font-weight: 400 !important; }
        .manage-partner-performer-page .wf-assign-meta > span > i { display: none !important; }
        .manage-partner-performer-page .wf-table,
        .manage-partner-performer-page .wf-table th,
        .manage-partner-performer-page .wf-table td,
        .manage-partner-performer-page .wf-table td * { color: #000 !important; font-size: 13px !important; font-weight: 400 !important; }
        .manage-partner-performer-page .wf-thead { background: #f8fafc !important; }
        .manage-partner-performer-page .wf-thead th { color: #475569 !important; font-size: 13px !important; font-weight: 400 !important; border-bottom-color: #e5e7eb !important; }
        .manage-partner-performer-page .wf-table-row:hover { background: linear-gradient(90deg,rgba(0,0,0,.045),rgba(0,0,0,.015)) !important; box-shadow: inset 3px 0 0 rgba(0,0,0,.45) !important; }
        .manage-partner-performer-page .wf-table-row.selected-row,
        .manage-partner-performer-page .wf-table-row.selected-row:hover { background: linear-gradient(90deg,rgba(0,0,0,.075),rgba(0,0,0,.025)) !important; box-shadow: inset 4px 0 0 #000 !important; }
        .manage-partner-performer-page .wf-table-row.selected-row td { color: #000 !important; font-weight: 400 !important; border-bottom-color: rgba(0,0,0,.12) !important; }
        .manage-partner-performer-page .wf-id-cell { padding: 0 !important; border: none !important; border-radius: 0 !important; background: transparent !important; color: #000 !important; }
        .manage-partner-performer-page .wf-id-cell i,
        .manage-partner-performer-page .wf-thead i,
        .manage-partner-performer-page .wf-table tbody td i { display: none !important; }
        .manage-partner-performer-page .wf-table tbody .wf-empty-state i {
          display: inline-block !important;
        }
        .manage-partner-performer-page .wf-table tbody .wf-empty-icon i {
          color: #525252 !important;
        }
        .manage-partner-performer-page .wf-name-avatar { background: #eef2f7 !important; border-color: #d1d5db !important; color: #64748b !important; box-shadow: none !important; }
        .manage-partner-performer-page .wf-name-main { color: #000 !important; font-weight: 600 !important; text-transform: uppercase !important; }
        .manage-partner-performer-page .wf-name-title,
        .manage-partner-performer-page .wf-data-line,
        .manage-partner-performer-page .wf-email-line { color: #000 !important; font-weight: 400 !important; }
        .manage-partner-performer-page .badge-capsule,
        .manage-partner-performer-page .badge-capsule * { font-weight: 400 !important; }
        .manage-partner-performer-page .wf-empty-icon { background: #f3f4f6 !important; border-color: #d1d5db !important; color: #525252 !important; box-shadow: none !important; }
        .manage-partner-performer-page .wf-empty-title { color: #171717 !important; font-weight: 400 !important; }
        .manage-partner-performer-page .wf-table td .badge-azure {
          background: rgba(37,99,235,0.08) !important;
          border: 1px solid rgba(37,99,235,0.15) !important;
          color: #1d4ed8 !important;
        }
        .manage-partner-performer-page .wf-table td .badge-system {
          background: #f1f5f9 !important;
          border: 1px solid #cbd5e1 !important;
          color: #475569 !important;
        }
        .manage-partner-performer-page .wf-table td .badge-active {
          background: rgba(16,185,129,0.08) !important;
          border: 1px solid rgba(16,185,129,0.15) !important;
          color: #047857 !important;
        }
        .manage-partner-performer-page .wf-table td .badge-inactive {
          background: rgba(239,68,68,0.08) !important;
          border: 1px solid rgba(239,68,68,0.15) !important;
          color: #b91c1c !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-action-search {
          background: #ffffff !important;
          border-color: #cbd5e1 !important;
          color: #475569 !important;
          box-shadow: none !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-action-search:hover {
          background: #f8fafc !important;
          border-color: #94a3b8 !important;
          color: #0f172a !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-primary-search {
          background: #2563eb !important;
          border-color: #2563eb !important;
          color: #ffffff !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-primary-search i {
          color: #ffffff !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-primary-search:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          color: #ffffff !important;
          box-shadow: 0 4px 10px -1px rgba(37,99,235,0.25) !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-primary-search:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          transform: none !important;
          box-shadow: none !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-danger-search {
          background: rgba(239,68,68,0.06) !important;
          border-color: rgba(239,68,68,0.18) !important;
          color: #dc2626 !important;
        }
        .manage-partner-performer-page .search-panel-collapse .btn-danger-search:hover {
          background: rgba(239,68,68,0.12) !important;
          border-color: rgba(239,68,68,0.28) !important;
          color: #b91c1c !important;
          box-shadow: 0 4px 8px -2px rgba(239,68,68,0.12) !important;
        }

      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card manage-partner-performer-page">
          {/* ── Premium Integrated Header ── */}
          <div className="wf-header-section">
            <div className="wf-header-left">
              <div className="wf-icon-box">
                <i className={partnerType === "Recruiter" ? "fa fa-user-circle-o" : "fa fa-building-o"} />
              </div>
              <div className="wf-title-block">
                <h2 className="wf-title">
                  <button
                    onClick={() => handleViewSubcontractorForm("Form", performerdata)}
                    className="btn p-0 btn-link text-uppercase"
                    style={{ fontSize: '20px', fontWeight: 600, color: '#0f172a', textAlign: 'left', verticalAlign: 'baseline' }}
                  >
                    {performerdata?.label || "Loading..."}
                    {performerdata?.fuid
                      ? " (Partner ID: " + performerdata.fuid + ")"
                      : ""}
                  </button>
                </h2>
                <p className="wf-subtitle">
                  {partnerType} &bull; Joined <Moment format="MMM Do YYYY">{performerdata?.createdDate}</Moment>
                </p>

                <div className="wf-header-meta">
                  <span className="wf-meta-pill is-active">
                    <i className="fa fa-check-circle" />
                    {activeCount} Active
                  </span>
                  <span className="wf-meta-pill is-inactive">
                    <i className="fa fa-times-circle" />
                    {Math.max(rowsCount - activeCount, 0)} Inactive
                  </span>
                  <span className="wf-meta-pill">
                    <i className="fa fa-users" />
                    {rowsCount} Users
                  </span>
                </div>

                <div className="wf-header-meta legacy-partner-meta">
                  <span className="wf-meta-pill">
                    <i className="fa fa-id-badge" /> ID: {performerdata?.fuid}
                  </span>
                  {item?.contact1?.performeremail && (
                    <span className="wf-meta-pill">
                      <i className="fa fa-envelope-o" /> {item.contact1.performeremail}
                    </span>
                  )}
                  <span className="wf-meta-pill">
                    <i className="fa fa-certificate" /> Enrollment: {performerdata?.enrollmentStatus ? "Complete" : "Pending"}
                  </span>

                  {/* Applications Meta Pills */}
                  {performerdata?.applications?.map((app, idx) => (
                    <span key={`app-pill-${idx}`} className="wf-meta-pill" style={{ borderColor: app.appSubmitted ? '#10b981' : '#f59e0b' }}>
                      <i className="fa fa-file-text-o" style={{ color: app.appSubmitted ? '#10b981' : '#f59e0b' }} />
                      App {app.applicationId}: {app.appSubmitted ? "Done" : "Review"}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="wf-header-right" style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
              <button
                className="btn-search-trigger"
                onClick={handleAddUser}
              >
                <i className="fa fa-user-plus" aria-hidden="true" /> Add User
              </button>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#partnerSearchPanel"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Reload users"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
              <button
                onClick={() => {
                  const returnTo = location.state?.returnTo;
                  const listState = location.state?.subcontractorListState;
                  if (returnTo && listState) {
                    navigate(returnTo, {
                      replace: true,
                      state: {
                        restoreSubcontractorList: true,
                        subcontractorListState: listState,
                      },
                    });
                    return;
                  }
                  navigate(-1);
                }}
                className="btn-search-trigger"
              >
                <i className="fa fa-arrow-left" aria-hidden="true" /> Back
              </button>
            </div>

          </div>

          {/* ── Toolbar ── */}
          <div className="wf-toolbar">
            <div className="d-flex align-items-center" style={{ gap: '14px' }}>
              <PageSizeOptions pageSize={pageSize} onChange={handlePageSizeChanged} />
              <span className="wf-meta-pill">
                <i className="fa fa-check-circle" aria-hidden="true" />
                {activeCount} Active
              </span>
              <span className="wf-meta-pill">
                <i className="fa fa-users" aria-hidden="true" />
                {rowsCount} Total
              </span>
            </div>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            </div>
          </div>

          {/* ── Search Panel ── */}
          <div className="px-3">
            <div className="collapse" id="partnerSearchPanel">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Users
                  </span>
                </div>
                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-2 form-group">
                      <label htmlFor="performerId" className="wf-control-label">
                        <i className="fa fa-hashtag" /> ID
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-hashtag wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          id="performerId"
                          className="form-control wf-input"
                          placeholder="e.g. 42"
                          value={performerId}
                          onChange={({ currentTarget }) => setPerformerId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="performerName" className="wf-control-label">
                        <i className="fa fa-id-card" /> Name
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-search wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          id="performerName"
                          className="form-control wf-input"
                          placeholder="Search user name..."
                          value={performerName}
                          onChange={({ currentTarget }) => setPerformerName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="mobile" className="wf-control-label">
                        <i className="fa fa-phone" /> Mobile No.
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-phone wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          id="mobile"
                          className="form-control wf-input"
                          placeholder="Mobile number..."
                          value={formatPhoneNumber(mobile)}
                          onChange={({ currentTarget }) => setMobile(currentTarget.value.replace(/[^\d]/g, ""))}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#partnerSearchPanel"
                    type="button"
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button className="btn-action-search" onClick={handleFilterCancel}>
                    <i className="fa fa-refresh" aria-hidden="true"></i>Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={handleFilter}
                    disabled={isFiltering || (!performerId.trim() && !performerName.trim() && !mobile.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true"></i>Apply Filters
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ── Tabs & Content ── */}
          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => setSelectedKey("home")}
              >
                <i className="fa fa-list-alt" />
                Users
                <span className="wf-tab-badge">{rowsCount}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "addedituser" ? " active" : ""}`}
                onClick={() => setSelectedKey("addedituser")}
              >
                <i className={`fa ${selectedUserId > 0 ? "fa-pencil-square-o" : "fa-user-plus"}`} />
                {selectedUserId > 0 ? "Edit" : "Add"} User
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "status" ? " active" : ""}`}
                onClick={() => setSelectedKey("status")}
              >
                <i className="fa fa-toggle-on" />
                Activate / Deactivate
              </button>
            </div>

            {selectedKey === "home" && (
              <div className="wf-tab-panel">
                {selectedUserId > 0 && selectedObj && (
                  <div className="wf-assign-card">
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedObj.name || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong style={{ display: 'block', fontSize: '14px' }}>{selectedObj.name} {selectedObj.lastName}</strong>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>
                          <i className="fa fa-envelope" style={{ marginRight: 4 }} />
                          {selectedObj.email}
                          {selectedObj.title && <> &bull; {selectedObj.title}</>}
                          &nbsp;&bull;&nbsp;
                          <span className={`badge-capsule ${selectedObj.status ? "badge-active" : "badge-inactive"}`} style={{ padding: "2px 8px", fontSize: 11 }}>
                            {selectedObj.status ? "Active" : "Inactive"}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions" style={{ display: 'flex', gap: '8px' }}>
                      <button className="btn-action-search btn-primary-search" onClick={() => handleTabSelect("addedituser")}>
                        <i className="fa fa-pencil-square-o" /> Edit
                      </button>
                      <button className="btn-action-search" onClick={() => handleTabSelect("status")}>
                        <i className="fa fa-toggle-on" /> Status
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                        style={{ padding: "8px 12px" }}
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="table-responsive mt-2 wf-table-scroll">
                  <table className="table align-items-center table-flush wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>
                          ID
                          {selectedUserId > 0 && (
                            <span
                              style={{ cursor: "pointer", marginLeft: 6 }}
                              onClick={handleResetSelection}
                              title="Reset Selection"
                            >
                              <i className="fa fa-refresh text-primary" aria-hidden="true" />
                            </span>
                          )}
                        </th>
                        <th>Date Added</th>
                        <th>Name &amp; Title</th>
                        <th>Email</th>
                        <th>Login Type</th>
                        <th>Azure Email</th>
                        <th>Contact No.</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {performers.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ padding: 0 }}>
                            <div className="wf-empty-state">
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-users"} aria-hidden="true" />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Users" : "No Users Assigned"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the filters to see users."
                                  : "There are no users assigned to this partner yet. Add a user to get started."}
                              </p>
                              {dataType === "filter" ? (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" /> Reset Filters
                                </button>
                              ) : (
                                <button
                                  className="btn-action-search btn-primary-search"
                                  onClick={handleAddUser}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-user-plus" /> Add First User
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        performers.map((performer, idx) => (
                          <tr
                            key={performer.id}
                            className={`wf-table-row${selectedUserId === performer.id ? " selected-row" : ""}`}
                            onClick={() => handleSelection(performer)}
                            style={{ animationDelay: `${idx * 0.04}s` }}
                            title={selectedUserId === performer.id ? `Click to deselect: ${performer.name}` : `Click to select: ${performer.name}`}
                          >
                            <td>
                              <span
                                className={`wf-id-cell${selectedUserId === performer.id ? " is-selected" : ""}`}
                              >
                                {selectedUserId === performer.id && (
                                  <i className="fa fa-check-circle text-primary" style={{ fontSize: "12px" }} />
                                )}
                                #{performer.id}
                              </span>
                            </td>
                            <td>
                              <span className="wf-data-line">
                                <i className="fa fa-calendar-o" aria-hidden="true" />
                                {performer.addedDateTime ? (
                                  <Moment format="MMM Do YYYY">{performer.addedDateTime}</Moment>
                                ) : (
                                  <span className="wf-empty-value">Not available</span>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">{getInitials(performer)}</span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{getDisplayName(performer)}</span>
                                  {performer.title ? (
                                    <span className="wf-name-title">{performer.title}</span>
                                  ) : (
                                    <span className="wf-empty-value">No title</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <span className="wf-data-line wf-email-line">
                                <i className="fa fa-envelope-o" aria-hidden="true" />
                                {performer.email || <span className="wf-empty-value">No email</span>}
                              </span>
                            </td>
                            <td>
                              {performer.loginType === 1 ? (
                                <span className="badge-capsule badge-azure">
                                  <i className="fa fa-windows" style={{ marginRight: 4 }} aria-hidden="true" />
                                  Azure AD
                                </span>
                              ) : (
                                <span className="badge-capsule badge-system">
                                  <i className="fa fa-desktop" style={{ marginRight: 4 }} aria-hidden="true" />
                                  System
                                </span>
                              )}
                            </td>
                            <td>
                              {performer.azureEmailId ? (
                                <span className="wf-data-line wf-email-line">
                                  <i className="fa fa-at" aria-hidden="true" />
                                  {performer.azureEmailId}
                                </span>
                              ) : (
                                <span className="wf-empty-value">Not linked</span>
                              )}
                            </td>
                            <td>
                              {performer.contact ? (
                                <span className="wf-data-line">
                                  <i className="fa fa-phone" aria-hidden="true" />
                                  {getFormatedNumber(performer.contact)}
                                </span>
                              ) : (
                                <span className="wf-empty-value">No contact</span>
                              )}
                            </td>
                            <td>
                              {performer.status ? (
                                <span className="badge-capsule badge-active">
                                  <i className="fa fa-check" style={{ marginRight: 4 }} aria-hidden="true" />
                                  Active
                                </span>
                              ) : (
                                <span className="badge-capsule badge-inactive">
                                  <i className="fa fa-times" style={{ marginRight: 4 }} aria-hidden="true" />
                                  Inactive
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    itemsCount={rowsCount}
                    onPageChange={handlePageChange}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            )}

            {selectedKey === "addedituser" && (
              <div className="wf-tab-panel pt-3">
                <AddPartnerPerformer
                  selectedObj={selectedObj}
                  currentUser={currentUser}
                  handleFormSubmit={handleFormSubmit}
                  handlePermissionShowHide={handlePermissionShowHide}
                  partnerType={partnerType}
                />
              </div>
            )}

            {selectedKey === "status" && (
              <div className="wf-tab-panel pt-3">
                {selectedUserId > 0 ? (
                  <ActiveDeactiveHistory
                    selectedObj={selectedObj}
                    type="performer"
                    typeName="user"
                    actionType={actionType}
                    handlePermissionShowHide2={handlePermissionShowHide2}
                  />
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-toggle-on" aria-hidden="true" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">
                      Select a user from the <strong>Users</strong> tab to activate, deactivate, or review their status history.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Users
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {wfForm && viewFormType && (
          <div className="p-0 border-0 mt-3 animation-fade-in" style={{ animation: 'tabFadeIn 0.4s ease both' }}>
            <div className="pop-container" style={{ border: '1px solid #e2e8f0', borderRadius: '16px', overflow: 'hidden', background: 'white', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
              <div className="pop-header" style={{ padding: '16px 24px', borderBottom: '1px solid #f1f5f9', background: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 className="m-0 text-primary" style={{ fontWeight: 600 }}>
                  <i className="fa fa-file-text-o mr-2" />
                  Partner Form Details
                </h4>
                <button
                  className="pop-action-btn back"
                  onClick={() => handleViewSubcontractorForm(`${viewFormType}`, null)}
                  style={{ background: 'white', border: '1px solid #cbd5e1', padding: '6px 16px', borderRadius: '8px', cursor: 'pointer' }}
                >
                  <i className="fa fa-times mr-2" />Close
                </button>
              </div>
              <div className="p-4">
                <WorkflowElement
                  wfTask={wfTask}
                  wfForm={wfForm}
                  handleNextTask={handleNextTask}
                  viewType={true}
                  appSummary={false}
                  codeVerified={true}
                  wfTaskType={"form"}
                  updatedStateData={updatedStateData}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
